import Header from '../../components/header';
import React from 'react';
import { PageWrapper } from './Layout.styles';
var Body = function (props) {
    var children = props.children, title = props.title, chip = props.chip;
    return (React.createElement("div", null,
        React.createElement(Header, { title: title, chip: chip }),
        React.createElement(PageWrapper, null, children)));
};
export default Body;
